<template>
  <div class="quiz__pressure">
    <div class="tonometer__wrapper">
      <div class="tonometer img">
        <img :src="mediaBaseUrl + 'quiz/tonometer/tonometer.svg'" alt="tonometer">
      </div>
      <img :src="mediaBaseUrl + 'quiz/tonometer/arrow.svg'" alt="arrow" class="arrow" :style="{transform: `translateX(-50%) rotate(${angle}deg)`}">
    </div>

    <div class="quiz__options">
      <div v-for="option in options" :key="option.text" class="option" :class="{option_active: value === option.text}" @click="() => handleSelect(option)">
        <div class="option__text">{{option.text}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "quiz-pressure",
  inject: ["mediaBaseUrl"],

  data() {
    return {
      angle: 165,
      value: this.$t('quiz.list[14].options[3]'),
      options: this.$t('quiz.list[14].options'),
      delayActive: false,
    };
  },

  methods: {
    handleSelect(option) {
      if (this.delayActive) {
        return;
      }
      this.value = option.text;
      this.angle = option.angle
      this.delayActive = true;

      setTimeout(() => {
        this.$emit("changeValue", option);
        this.delayActive = false;
      }, 500);
    },
  },
}
</script>

<style scoped>

</style>